<style type="scss">

</style>
<template>
    <v-dialog v-model="showDialog" max-width="500px" scrollable>
        <v-card v-if="product">
            <v-card-title class="headline align-start flex-column pa-2 primary primarytext--text">
                <div class="fill-width d-flex">
                    <span v-text="product.name" style="max-width: calc(100% - 35px); overflow:hidden; text-overflow:ellipsis; white-space:nowrap; display:block; margin-right:auto;" />
                    <v-btn icon @click="showDialog = false" class="float-right"><v-icon class="primary primarytext--text">mdi-close</v-icon></v-btn>
                </div>
            </v-card-title>
            <!-- If there is no product description set max-height="55vh", if there is a description set max-height="30%" if the combined length of name and description is more than 600 characters, otherwise set max-height="45%" -->
            <v-auto-img :src="product.imagekey" :height="imgHeight" :max-height="imgMaxHeight" class="mb-2"></v-auto-img>
            <v-card-text>
                <div class="font-weight-bold">{{product.name}}</div>

                <div v-html="product.description" />

                <div v-if="product.auto" class="my-1">
                    <v-icon color="primary">mdi-refresh</v-icon>
                    {{$translate('Recurring, automatically extended')}}
                </div>

                <div v-else-if="product.period" class="my-1">
                    <v-icon color="primary">mdi-calendar-clock</v-icon>
                    {{$translate('Valid from')}} {{product.periodValidFrom}} {{$translate('to')}} {{product.periodValidTo}}
                </div>

                <div v-else-if="product.validTime" class="my-1">
                    <div v-if="product.validFromDate">
                        <v-icon color="primary">mdi-calendar-clock</v-icon>
                        {{$translate('Valid until')}} {{ calculateAndFormatEndDate(product.validFromDate) }}
                    </div>
                    <div v-else>
                        <v-icon color="primary">mdi-calendar-clock</v-icon>
                        {{$translate('Valid for')}} {{product.validTime}} {{$translate(product.validType + (product.validTime === 1 ? '' : 's')).toLowerCase()}} {{$translate('from purchase')}}
                    </div>
                </div>

                <div v-if="product.boundTime" class="my-1">
                    <v-icon color="primary">mdi-calendar-clock</v-icon>
                    {{$translate('Bound for')}} {{product.boundTime}} {{$translate(product.boundType + (product.boundTime === 1 ? '' : 's')).toLowerCase()}}
                </div>

                <div v-if="product.trainingsessions" class="my-1">
                    <v-icon color="primary">mdi-ticket-confirmation-outline</v-icon> {{product.trainingsessions}} {{$translate('Punch tickets').toLowerCase()}}
                </div>

                <div v-if="product.workout" class="my-1">
                    <v-icon color="primary">mdi-ticket-confirmation-outline</v-icon> {{$translate('Workout booking included')}}
                </div>

                <div v-if="product.entry" class="my-1">
                    <v-icon color="primary">mdi-door-closed-lock</v-icon> {{$translate('Enables on-site access')}}
                </div>

                <v-expansion-panels v-if="product.sites && product.sites.length > 1" accordion flat>
                    <v-expansion-panel>
                        <v-expansion-panel-header class="pa-0 text--secondary" style="min-height: 20px !important">
                            <div><v-icon color="primary">mdi-map-marker-star-outline</v-icon> {{$translate('Valid in multiple locations')}}</div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <div v-for="site in product.sites.map(site_id => $store.state.settings.sites.find(site => site.id == site_id)).sort((a,b) => a.name.localeCompare(b.name))" :key="site.id">
                                {{site.name}}
                            </div>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>

            </v-card-text>

            <v-card-actions class="d-flex flex-column">
                <div class="d-flex flex-row fill-width align-center">
                    <v-select class="flex-grow-1 mr-2" :label="$translate('Choose variant')" :items="variants" item-text="name" item-value="name" v-model="variant" v-if="hasVariants" />

                    <product-count v-if="showProductCount" v-model="count" class="ml-1 mb-2 mt-1" :zero="false" />
                </div>

                <div class="d-flex flex-row fill-width align-center" v-if="product.payWhatYouWant">
                    <v-text-field :label="$translate('Enter amount')" v-model="amount" />
                </div>
                <v-btn class="zoezi-button-thin" color="primary" block @click="buy" :disabled="!canBuy">{{$translate('Buy')}} {{priceString}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { getCartPriceString, formatPrice } from '../util';
import ProductCount from './ProductCount.vue';
export default {
    name: 'zoezi-trainingcard-product-dialog',

    props: {
        value: {
            type: Boolean
        },
        product: {
            type: Object
        },
        basket: {
            type: Array
        },
        siteId: {
            type: Number,
            default: 1
        },
        cropImage: {
            type: Boolean,
            default: true
        }

    },

    components: { ProductCount },

    watch: {
        value: {
            immediate: true,
            handler(value) {
                this.showDialog = value;
                this.count = 1;
                this.variant = null;
                this.amount = 0;
            }
        },
        showDialog(value) {
            this.$emit('input', value);
        }
    },

    computed: {
        showProductCount() {
            return this.product && this.product.type != 'course' && this.product.type != 'valuecard';
        },
        imgHeight() {
            return this.cropImage ? '335px' : 'auto';
        },
        imgMaxHeight() {
            return this.product.description ? this.product.name.length + this.product.description.length > 600 ? '30%' : '45%' : '55vh';
        },
        priceString() {
            if (this.product.payWhatYouWant) {
                return formatPrice(this.amount);
            } else {
                return getCartPriceString([{product: this.product, count: this.count}]);
            }
        },
        hasVariants() {
            return !(this.variants.length == 1 && this.variants[0].name === null);
        },
        variants() {
            if (!this.product.variants || this.product.variants.length == 0) {
                return [{name: null, stock: this.product.stock}]
            }

            return this.product.variants;
        },
        canBuy() {
            return (!this.hasVariants || !!this.variant) && (!this.product.payWhatYouWant || this.amount);
        },
        stock() {
            let variant = this.variants.find(v => v.name == this.variant);
            if (!variant) {
                return 0;
            }
            let ss = variant.stock_sites?.find(x => x.site_id == this.siteId);
            let stock = ss ? ss.stock : null;
            if (stock != null && this.basket) {
                let bi = this.basket.find(item => item.product_id == this.product.id && variant.name == item.variant);
                if (bi && bi.count) {
                    stock -= bi.count;
                }
                return Math.max(0, stock);
            }

            return stock;
        },
    },

    data: () => ({
        showDialog: false,
        count: 1,
        variant: null,
        amount: 0
    }),

    methods: {
        buy() {
            if (this.stock != null && this.stock < this.count) {
                let text = this.stock > 0 ? this.$translate('There is only {0} of this product in stock').format(this.stock) : this.$translate('There are no products left in stock');
                this.$store.commit('showSnackBar', {text});
            } else {
                let result = {product: this.product, variant: this.variant, count: this.count};
                if (this.product.payWhatYouWant) {
                    result.price = this.amount;
                }
                this.$emit('buy', result)
                this.showDialog = false;
            }
        },
        calculateAndFormatEndDate(date) {
            let dateObj = Date.newFull(date);
            dateObj.setDate(dateObj.getDate() - 1);
            return Date.formatFullShorter(dateObj);
        },
    }
}
</script>
